import config from 'src/config'
import { getNewsletterStorefront } from 'src/functions/newsletterStorefront'
import TopMarken from 'src/layout/Footer/TopMarken'
import type { MenuPageBuilderBrandListBlock } from 'src/shared/dbTypes/menuPageBuilder'
import type { LandingPageImageAiGenerated } from 'src/functions/landingPageImageAiGenerated'

export default function HomeBrands({ brandBlock, landingPageImageAiGenerated }: {
  brandBlock?: MenuPageBuilderBrandListBlock; landingPageImageAiGenerated?: LandingPageImageAiGenerated
}) {
  const storefront = getNewsletterStorefront(config.shop?.shop)
  if (!storefront) return null
  return <TopMarken presentation='home' homeStyle={storefront.style} brandBlock={brandBlock} landingPageImageAiGenerated={landingPageImageAiGenerated} />
}
